import { render, staticRenderFns } from "./login-layout.vue?vue&type=template&id=3a848c3c&scoped=true"
import script from "./login-layout.vue?vue&type=script&lang=js"
export * from "./login-layout.vue?vue&type=script&lang=js"
import style0 from "./login-layout.vue?vue&type=style&index=0&id=3a848c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a848c3c",
  null
  
)

export default component.exports